import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  userActivityReports: [],
  downloadUserActivityReportsFile: [],
  userList: [],
  filter: {},
  isLoading: false,
  isLoadingUserActivityReportsDownload: false,
  error: null,
};

export const getUserActivityReports: any = createAsyncThunk(
  "content/getUserActivityReports",
  async ({
    PageNumber,
    pageSize,
    userId = null,
    startDate = null,
    endDate = null,
    SortBy,
    SortDirection,
  }: any) => {
    const payload = {
      PageNumber,
      pageSize,
      userId,
      startDate,
      endDate,
      SortBy,
      SortDirection,
    };
    const res = await axios.post(
      `/slpapp/Report/getUserActivityReport`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const downloadUserActivityReportsFile: any = createAsyncThunk(
  "content/downloadUserActivityReportsFile",
  async ({
    fileType = "downloadPdf",
    // tcCode = null,
    // siteCode = null,
    // blockCode = null,
    userId = null,
    startDate = null,
    endDate = null,
  }: any) => {
    const payload = {
      // tcCode,
      // siteCode,
      // blockCode,
      userId,
      startDate,
      endDate,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getUserActivityReport/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();

      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      // if (fileType === "downloadPdf") {
      //   link.download = filename;
      // } else {
      //   link.download = filename;
      // }
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading user activity report:", error);
      throw error;
    }
  }
);

export const getUserList: any = createAsyncThunk(
  "content/getUserList",
  async () => {
    const res = await axios.get(`/slpapp/User/getAllUsers`);
    const data = await res.data;

    return data;
  }
);

export const userActivityReportSlice = createSlice({
  name: "userActivityReport",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserActivityReports.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserActivityReports.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userActivityReports = action.payload;
    });
    builder.addCase(getUserActivityReports.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getUserList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userList = action.payload;
    });
    builder.addCase(getUserList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(downloadUserActivityReportsFile.pending, (state) => {
      state.isLoadingUserActivityReportsDownload = true;
    });
    builder.addCase(
      downloadUserActivityReportsFile.fulfilled,
      (state, action) => {
        state.isLoadingUserActivityReportsDownload = false;
        state.downloadUserActivityReportsFile = action.payload;
      }
    );
    builder.addCase(
      downloadUserActivityReportsFile.rejected,
      (state, action) => {
        state.isLoadingUserActivityReportsDownload = false;
        state.error = action.error.message;
      }
    );
  },
});

export const { setFilter } = userActivityReportSlice.actions;

export default userActivityReportSlice.reducer;
